import { formatCompactCurrency, formatCurrency, toCents } from './currency';

const RAISED = 'align-super text-heading-sm';

interface HeroAmountProps {
  /** In dollars. */
  value: number;
  /** At or above this many dollars the figure abbreviates, for a result that can overflow its column. */
  compactThreshold?: number;
}

/** Avoid `<sup>` because global styles and assistive technology treat it as a footnote marker. */
export const HeroAmount = ({ value, compactThreshold }: HeroAmountProps) => {
  const cents = toCents(value);
  const dollars = Math.trunc(cents / 100).toLocaleString('en-US');

  return (
    <p className="text-heading-lg">
      <span className="sr-only">{formatCurrency(value)}</span>
      {compactThreshold !== undefined && value >= compactThreshold ? (
        <span aria-hidden>{formatCompactCurrency(value)}</span>
      ) : (
        <span aria-hidden>
          <span className={RAISED}>$</span>
          {dollars}.<span className={RAISED}>{String(cents % 100).padStart(2, '0')}</span>
        </span>
      )}
    </p>
  );
};
